import { IGroupInfo } from '@/api/types/product';
import { setSession } from '@/utils/tools';
import { SearchOutlined } from '@zeelool/icon';
import Link from 'next/link';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

export default function RelatedBlockLink({
  item,
  index,
  trackProductListPageRelatedGroupClick,
  trackProductListPageRelatedGroupExp,
  isWeb = false,
}: {
  item: IGroupInfo['related_block_link'][0];
  index: number;
  trackProductListPageRelatedGroupClick: (item: any, index: number, position: string) => void;
  trackProductListPageRelatedGroupExp: (item: any, index: number, position: string) => void;
  isWeb?: boolean;
}) {
  const { ref, inView } = useInView();
  useEffect(() => {
    if (inView) {
      trackProductListPageRelatedGroupExp(item, index, '底部相关导航位');
    }
  }, [inView]);

  return (
    <Link
      key={index}
      ref={ref}
      href={`/goods-list/${item.path || item.group_link}`}
      className={`
        flex items-center border  text-12 hover:bg-gray-50 transition-colors
        ${
          isWeb
            ? 'h-[32px] text-14 pr-16 pl-12 rounded-[20px] border-[#808080]'
            : 'pr-[13px] pl-[11px] h-[28px] border-primary-text rounded-[14px]'
        }
      `}
      onClick={() => {
        setSession('zl_goodsListEnterPageScene', '商品列表页底部相关导航位');
        trackProductListPageRelatedGroupClick(item, index, '底部相关导航位');
      }}
    >
      <SearchOutlined className="mr-[3px] text-primary-text text-[17px]" />
      <span className="text-primary-text max-w-[294px] truncate block">{item.link_name}</span>
    </Link>
  );
}
